import { cn } from '@/lib/utils';

export type TooltipTitleProps = React.ComponentProps<'span'>;

const TooltipTitle = ({ className, ...props }: TooltipTitleProps) => {
  return (
    <span
      data-slot="tooltip-title"
      className={cn(
        'font-sans text-xs leading-4 font-normal tracking-[-0.41px] text-primary',
        className,
      )}
      {...props}
    />
  );
};

export default TooltipTitle;
